import moment from "moment";

export function useTimerSetup() {
    function calculateProperEndDate(value) {
        const valueMoment = moment(value);
        // fallback to the current datetime!
        const computedMoment = valueMoment.isValid() ? valueMoment : moment();

        return {
            endDate: valueMoment.toDate(),
            endHour: computedMoment.format("HH:mm:ss"),
        };
    }

    // mutating function here:
    function decorateTimerWithEndDate(value, timer) {
        const result = calculateProperEndDate(value);
        for (const key in result) {
            timer[key] = result[key];
        }
    }

    return { calculateProperEndDate, decorateTimerWithEndDate };
}
